import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28512bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalText" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Вы точно хотите продолжить?", -1))
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = {
  key: 0,
  class: "CreateBidTMS__cities CreateBidTMS__box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_8 = { class: "w-full flex items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4" }
const _hoisted_11 = { class: "CreateBidTMS__box grid grid-cols-1 gap-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CreateBidTMS__text" }, "Грузоотправитель", -1))
const _hoisted_13 = { class: "CreateBidTMS__box grid grid-cols-1 gap-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CreateBidTMS__text" }, "Грузополучатель", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CreateBidTMS__title" }, "Характеристика груза", -1))
const _hoisted_16 = { class: "CreateBidTMS__box" }
const _hoisted_17 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CreateBidTMS__title" }, "Данные водителя и т/с", -1))
const _hoisted_19 = { class: "CreateBidTMS__box grid grid-cols-1 gap-4" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_22 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_25 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4" }
const _hoisted_26 = { class: "mt-3 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_add_courier_modal = _resolveComponent("add-courier-modal")!
  const _component_add_car_modal = _resolveComponent("add-car-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_iconRefresh = _resolveComponent("iconRefresh")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_cost)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          loading: _ctx.state.is_loading,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_cost = false)),
          onSubmit: _ctx.onSubmitCost,
          class: "NewModal__square",
          title: "Превышение нормы себестоимости",
          "with-cancel-button": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", null, [
                _createTextVNode(" Вы превышаете норму себестоимости ("),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.state.cost || '...') + " ₸", 1),
                _createTextVNode(") по направлению "),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.state.direction || '...'), 1),
                _createTextVNode(" . ")
              ]),
              _hoisted_4
            ]),
            _createVNode(_component_the_textarea, {
              class: "mt-2",
              autoheight: "",
              rows: 4,
              placeholder: "Укажите причину",
              value: _ctx.payload.comment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.comment) = $event)),
              "is-invalid": _ctx.state_form$.comment.$error,
              "validation-errors": _ctx.state_form$.comment.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.courier_state.is_opened)
      ? (_openBlock(), _createBlock(_component_add_courier_modal, {
          key: 1,
          loading: _ctx.courier_state.is_loading,
          onCreate: _ctx.createCourier,
          onCancel: _ctx.toggleCourier,
          onSetCar: _ctx.setCar
        }, null, 8, ["loading", "onCreate", "onCancel", "onSetCar"]))
      : _createCommentVNode("", true),
    (_ctx.car_state.is_opened)
      ? (_openBlock(), _createBlock(_component_add_car_modal, {
          key: 2,
          loading: _ctx.car_state.is_loading,
          onCreate: _ctx.createCar,
          onCancel: _ctx.toggleCar
        }, null, 8, ["loading", "onCreate", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, {
      class: "mt-3",
      title: "Создание заявки"
    }),
    _createElementVNode("form", {
      class: "CreateBidTMS",
      onSubmit: _cache[48] || (_cache[48] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCreateBid && _ctx.onCreateBid(...args)), ["prevent"]))
    }, [
      _createVNode(_component_new_select, {
        class: "w-full mr-2",
        placeholder: "Перевозчик",
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.validation$.carrierId.$error,
        "validation-errors": _ctx.validation$.carrierId.$errors,
        "search-without-refresh": "",
        "infinite-scroll": "",
        options: _ctx.data_state.carriers.list,
        value: _ctx.payload.carrierId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.carrierId) = $event)),
        onRefresh: _ctx.loadCarriers,
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
        onSearch: _ctx.searchCarriers,
        onOptionBySearch: _ctx.unshiftFindedCarrier,
        onChange: _ctx.onCarrierChange
      }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh", "onSearch", "onOptionBySearch", "onChange"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_new_checkbox, {
          class: "checkbox--blue",
          value: _ctx.payload.isProject,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.isProject) = $event)),
          disabled: _ctx.state.is_loading,
          label: "Проект",
          "return-integer": ""
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_new_checkbox, {
          class: "checkbox--blue",
          value: _ctx.payload.isAdditionalLoad,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.isAdditionalLoad) = $event)),
          disabled: _ctx.state.is_loading,
          label: "Догруз",
          "return-integer": ""
        }, null, 8, ["value", "disabled"])
      ]),
      (_ctx.citiesLength)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.cityIds, (city_id, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `city-${idx}`,
                class: "cities__item"
              }, [
                (_ctx.isAddCity(idx))
                  ? (_openBlock(), _createBlock(_component_new_button, {
                      key: 0,
                      class: "primary small my-2",
                      onClick: ($event: any) => (_ctx.addCity(idx))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_new_select, {
                    class: "cities__city",
                    placeholder: _ctx.getCityPlaceholder(idx),
                    loading: _ctx.data_state.cities.is_loading,
                    failed: _ctx.data_state.cities.is_failed,
                    "error-text": "При получении списка городов произошла ошибка",
                    options: _ctx.data_state.cities.list,
                    value: _ctx.payload.cityIds[idx],
                    "onUpdate:value": ($event: any) => ((_ctx.payload.cityIds[idx]) = $event),
                    "is-invalid": !_ctx.payload.cityIds[idx],
                    onRefresh: _ctx.loadCities,
                    onChange: ($event: any) => (_ctx.onCitySelect(idx))
                  }, null, 8, ["placeholder", "loading", "failed", "options", "value", "onUpdate:value", "is-invalid", "onRefresh", "onChange"]),
                  (_ctx.isDelete(idx))
                    ? (_openBlock(), _createBlock(_component_new_button, {
                        key: 0,
                        class: "NewButton--red ml-2",
                        disabled: _ctx.data_state.cities.is_loading,
                        onClick: ($event: any) => (_ctx.deleteCity(idx))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_new_select, {
            placeholder: "Грузоотправитель",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            disabled: _ctx.state.is_loading,
            "is-invalid": _ctx.validation$.senderCompanyId.$error,
            "validation-errors": _ctx.validation$.senderCompanyId.$errors,
            "search-without-refresh": "",
            "infinite-scroll": "",
            options: _ctx.data_state.companies.list,
            value: _ctx.payload.senderCompanyId,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.senderCompanyId) = $event)),
            onRefresh: _ctx.loadCompanies,
            onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
            onSearch: _ctx.searchCompanies,
            onOptionBySearch: _ctx.unshiftFindedCompany
          }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
          _createVNode(_component_new_input, {
            placeholder: "Адрес загрузки",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.loadAddress,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payload.loadAddress) = $event)),
            "is-invalid": _ctx.validation$.loadAddress.$error,
            "validation-errors": _ctx.validation$.loadAddress.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Дата загрузки",
            type: "date",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.dateOfLoad,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload.dateOfLoad) = $event)),
            "is-invalid": _ctx.validation$.dateOfLoad.$error,
            "validation-errors": _ctx.validation$.dateOfLoad.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Контактное лицо отправителя",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.sender_full_name,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payload.sender_full_name) = $event)),
            "is-invalid": _ctx.validation$.sender_full_name.$error,
            "validation-errors": _ctx.validation$.sender_full_name.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Номер отправителя",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.sender_phone,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payload.sender_phone) = $event)),
            "is-invalid": _ctx.validation$.sender_phone.$error,
            "validation-errors": _ctx.validation$.sender_phone.$errors,
            maska: _ctx.PHONE_NUMBER_MASK
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_new_select, {
            placeholder: "Грузополучатель",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            disabled: _ctx.state.is_loading,
            "is-invalid": _ctx.validation$.receiverCompanyId.$error,
            "validation-errors": _ctx.validation$.receiverCompanyId.$errors,
            "search-without-refresh": "",
            "infinite-scroll": "",
            options: _ctx.data_state.companies.list,
            value: _ctx.payload.receiverCompanyId,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload.receiverCompanyId) = $event)),
            onRefresh: _ctx.loadCompanies,
            onLoadmore: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
            onSearch: _ctx.searchCompanies,
            onOptionBySearch: _ctx.unshiftFindedCompany
          }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
          _createVNode(_component_new_input, {
            placeholder: "Адрес разгрузки",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.unloadAddress,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.payload.unloadAddress) = $event)),
            "is-invalid": _ctx.validation$.unloadAddress.$error,
            "validation-errors": _ctx.validation$.unloadAddress.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Дата разгрузки",
            disabled: _ctx.state.is_loading,
            type: "date",
            value: _ctx.payload.dateOfUnload,
            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.payload.dateOfUnload) = $event)),
            "is-invalid": _ctx.validation$.dateOfUnload.$error,
            "validation-errors": _ctx.validation$.dateOfUnload.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Контактное лицо получателя",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.receiver_full_name,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.payload.receiver_full_name) = $event)),
            "is-invalid": _ctx.validation$.receiver_full_name.$error,
            "validation-errors": _ctx.validation$.receiver_full_name.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Номер получателя",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.receiver_phone,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.payload.receiver_phone) = $event)),
            "is-invalid": _ctx.validation$.receiver_phone.$error,
            "validation-errors": _ctx.validation$.receiver_phone.$errors,
            maska: _ctx.PHONE_NUMBER_MASK
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"])
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_new_input, {
            placeholder: "Характер груза, вес, объем",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.natureOfCargo,
            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.payload.natureOfCargo) = $event)),
            "is-invalid": _ctx.validation$.natureOfCargo.$error,
            "validation-errors": _ctx.validation$.natureOfCargo.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Страхование",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.insurance,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.payload.insurance) = $event)),
            "is-invalid": _ctx.validation$.insurance.$error,
            "validation-errors": _ctx.validation$.insurance.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Тип кузова",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.bodyType,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.payload.bodyType) = $event)),
            "is-invalid": _ctx.validation$.bodyType.$error,
            "validation-errors": _ctx.validation$.bodyType.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Температурный режим",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.temperatureRegime,
            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.payload.temperatureRegime) = $event)),
            "is-invalid": _ctx.validation$.temperatureRegime.$error,
            "validation-errors": _ctx.validation$.temperatureRegime.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Стоимость перевозки",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.costOfTransportation,
            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.payload.costOfTransportation) = $event)),
            "is-invalid": _ctx.validation$.costOfTransportation.$error,
            "validation-errors": _ctx.validation$.costOfTransportation.$errors,
            maska: _ctx.PRICE_MASK
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"]),
          _createVNode(_component_new_input, {
            placeholder: "Срок и форма оплаты",
            value: _ctx.termAndFormOfPayment,
            disabled: ""
          }, null, 8, ["value"]),
          _createVNode(_component_new_checkbox, {
            class: "checkbox--blue",
            value: _ctx.payload.isNds,
            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.payload.isNds) = $event)),
            disabled: true,
            label: "С НДС",
            "return-integer": ""
          }, null, 8, ["value"])
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_new_select, {
            class: "w-full mr-2",
            placeholder: "Водитель",
            loading: _ctx.data_state.couriers.is_loading,
            failed: _ctx.data_state.couriers.is_failed,
            "error-text": "При получении списка водителей произошла ошибка",
            options: _ctx.data_state.couriers.list,
            value: _ctx.payload.id,
            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.payload.id) = $event)),
            "is-invalid": _ctx.validation$.id.$error,
            "validation-errors": _ctx.validation$.id.$errors,
            "search-without-refresh": "",
            label: "fullName",
            onRefresh: _ctx.loadCouriers,
            onSearch: _ctx.searchCouriers,
            onOptionBySearch: _ctx.unshiftFindedCourier,
            onChange: _ctx.onCourierSelect
          }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch", "onChange"]),
          _createVNode(_component_new_button, {
            class: "NewButton--large primary mr-2",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.loadCouriers(1))),
            loading: _ctx.data_state.couriers.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_iconRefresh)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_new_button, {
            class: "NewButton--large primary",
            onClick: _ctx.toggleCourier
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_new_input, {
          class: "w-full",
          placeholder: "ИИН",
          disabled: Boolean(_ctx.state.is_loading || _ctx.payload.id),
          value: _ctx.payload.iin,
          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.payload.iin) = $event)),
          "is-invalid": _ctx.validation$.iin.$error,
          "validation-errors": _ctx.validation$.iin.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_new_input, {
            placeholder: "ФИО водителя",
            disabled: Boolean(_ctx.state.is_loading || _ctx.payload.id),
            value: _ctx.payload.full_name,
            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.payload.full_name) = $event)),
            "is-invalid": _ctx.validation$.full_name.$error,
            "validation-errors": _ctx.validation$.full_name.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Телефон",
            disabled: Boolean(_ctx.state.is_loading || _ctx.payload.id),
            value: _ctx.payload.phone_number,
            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.payload.phone_number) = $event)),
            "is-invalid": _ctx.validation$.phone_number.$error,
            "validation-errors": _ctx.validation$.phone_number.$errors,
            maska: _ctx.PHONE_NUMBER_MASK
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_new_select, {
            class: "w-full mr-2",
            placeholder: "Автомобиль",
            loading: _ctx.data_state.cars.is_loading,
            failed: _ctx.data_state.cars.is_failed,
            "error-text": "При получении списка автомобилей произошла ошибка",
            options: _ctx.data_state.cars.list,
            value: _ctx.payload.car_id,
            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.payload.car_id) = $event)),
            "is-invalid": _ctx.validation$.car_id.$error,
            "validation-errors": _ctx.validation$.car_id.$errors,
            "search-without-refresh": "",
            "infinite-scroll": "",
            onRefresh: _ctx.loadCars,
            onLoadmore: _cache[30] || (_cache[30] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
            onSearch: _ctx.searchCars,
            onOptionBySearch: _ctx.unshiftFindedCar,
            onChange: _ctx.onCarSelect
          }, {
            "selected-option": _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
            ]),
            option: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
            ]),
            _: 1
          }, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch", "onChange"]),
          _createVNode(_component_new_button, {
            class: "NewButton--large primary mr-2",
            onClick: _ctx.loadCars,
            loading: _ctx.data_state.cars.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_iconRefresh)
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_new_button, {
            class: "NewButton--large primary",
            onClick: _ctx.toggleCar
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_new_input, {
            placeholder: "Гос.номер",
            disabled: _ctx.state.is_loading || _ctx.payload.car_id,
            value: _ctx.payload.number,
            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.payload.number) = $event)),
            "is-invalid": _ctx.validation$.number.$error,
            "validation-errors": _ctx.validation$.number.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Марка авто",
            disabled: _ctx.state.is_loading || _ctx.payload.car_id,
            value: _ctx.payload.brand,
            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.payload.brand) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_new_input, {
            placeholder: "Тип Т/С",
            disabled: _ctx.state.is_loading || _ctx.payload.car_id,
            value: _ctx.payload.type,
            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.payload.type) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_new_input, {
            placeholder: "ФИО Собственника Т/С",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.vehicleOwnerFullName,
            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.payload.vehicleOwnerFullName) = $event)),
            "is-invalid": _ctx.validation$.vehicleOwnerFullName.$error,
            "validation-errors": _ctx.validation$.vehicleOwnerFullName.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Кубатура",
            value: _ctx.payload.cubature,
            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.payload.cubature) = $event)),
            "is-invalid": _ctx.validation$.cubature.$error,
            "validation-errors": _ctx.validation$.cubature.$errors,
            disabled: _ctx.state.is_loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_new_select, {
            placeholder: "Грузоподъемность",
            value: _ctx.payload.carCapacityId,
            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.payload.carCapacityId) = $event)),
            "is-invalid": _ctx.validation$.carCapacityId.$error,
            "validation-errors": _ctx.validation$.carCapacityId.$errors,
            disabled: _ctx.state.is_loading,
            loading: _ctx.data_state.ftl_car_types.is_loading,
            failed: _ctx.data_state.ftl_car_types.is_failed,
            "error-text": "При получении списка грузоподъемностей произошла ошибка",
            options: _ctx.data_state.ftl_car_types.list,
            label: "title",
            "search-by": "title",
            onRefresh: _cache[37] || (_cache[37] = ($event: any) => (_ctx.loadFtlCarTypes(_ctx.data_state.ftl_car_types.pagination.current_page)))
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options"]),
          _createVNode(_component_new_input, {
            placeholder: "Номер тех. паспорта",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.technicalPassport,
            "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.payload.technicalPassport) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_new_input, {
            placeholder: "Гос. номер прицепа",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.trailerLicenseNumber,
            "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.payload.trailerLicenseNumber) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_new_input, {
            placeholder: "Номер удостоверения личности",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.identifyCard,
            "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.payload.identifyCard) = $event)),
            "is-invalid": _ctx.validation$.identifyCard.$error,
            "validation-errors": _ctx.validation$.identifyCard.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Номер водительского удостоверения",
            disabled: _ctx.state.is_loading,
            value: _ctx.payload.licence,
            "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.payload.licence) = $event)),
            "is-invalid": _ctx.validation$.licence.$error,
            "validation-errors": _ctx.validation$.licence.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Дата выдачи удостоверения личности",
            disabled: _ctx.state.is_loading,
            type: "date",
            value: _ctx.payload.identifyCardDate,
            "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.payload.identifyCardDate) = $event)),
            "is-invalid": _ctx.validation$.identifyCardDate.$error,
            "validation-errors": _ctx.validation$.identifyCardDate.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            placeholder: "Дата выдачи водительского удостоверения",
            disabled: _ctx.state.is_loading,
            type: "date",
            value: _ctx.payload.licenceDate,
            "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.payload.licenceDate) = $event)),
            "is-invalid": _ctx.validation$.licenceDate.$error,
            "validation-errors": _ctx.validation$.licenceDate.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_file_reader, {
            placeholder: "Фото тех. паспорта",
            "is-invalid": _ctx.validation$.carTechnicalPassportFiles.$error,
            "validation-errors": _ctx.validation$.carTechnicalPassportFiles.$errors,
            value: _ctx.payload.carTechnicalPassportFiles,
            "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.payload.carTechnicalPassportFiles) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_new_checkbox, {
            class: "checkbox--blue",
            value: _ctx.payload.isTripartite,
            "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.payload.isTripartite) = $event)),
            disabled: _ctx.state.is_loading,
            label: "Трех. стор договор",
            "return-integer": ""
          }, null, 8, ["value", "disabled"]),
          (_ctx.payload.isTripartite)
            ? (_openBlock(), _createBlock(_component_new_input, {
                key: 0,
                disabled: _ctx.state.is_loading,
                placeholder: "Номер договора",
                value: _ctx.payload.tripartiteNumber,
                "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.payload.tripartiteNumber) = $event)),
                "is-invalid": _ctx.validation$.tripartiteNumber.$error,
                "validation-errors": _ctx.validation$.tripartiteNumber.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
            : _createCommentVNode("", true),
          (_ctx.payload.isTripartite)
            ? (_openBlock(), _createBlock(_component_new_input, {
                key: 1,
                disabled: _ctx.state.is_loading,
                placeholder: "Дата договора",
                type: "date",
                value: _ctx.payload.tripartiteDate,
                "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.payload.tripartiteDate) = $event)),
                "is-invalid": _ctx.validation$.tripartiteDate.$error,
                "validation-errors": _ctx.validation$.tripartiteDate.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_new_button, {
          type: "submit",
          class: "NewButton--search ml-2",
          disabled: _ctx.state.is_loading,
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ], 64))
}